// extracted by mini-css-extract-plugin
export default {"container":"container__698424d3","list":"list__698424d3","item":"item__698424d3"};